import type { SkillGroup } from '@pages/PracticePage/model';
import { usePracticeView } from '@pages/PracticePage/model';

import { PracticePriorityList } from './PracticePriorityList';
import { SkillGroupList } from './SkillGroupList';

interface PracticeLessonsProps {
  groups: SkillGroup[];
}

export const PracticeLessons = ({ groups }: PracticeLessonsProps) => {
  const { viewMode, groupByTopic } = usePracticeView();

  const structuredItems = groups.flatMap((group) =>
    group.items.map((item) => ({ ...item, group: group.title }))
  );

  if (viewMode === 'priority') {
    const priorityItems = structuredItems
      .slice()
      .sort((first, second) => first.score - second.score || first.title.localeCompare(second.title));

    if (groupByTopic) {
      const groupedPriority = groups.map((group) => ({
        ...group,
        items: group.items
          .slice()
          .sort((first, second) => first.score - second.score || first.title.localeCompare(second.title)),
      }));

      return <SkillGroupList groups={groupedPriority} />;
    }

    return <PracticePriorityList items={priorityItems} />;
  }

  if (!groupByTopic) {
    return <PracticePriorityList items={structuredItems} title="All lessons" subtitle="" />;
  }

  return <SkillGroupList groups={groups} />;
};
